import { combineReducers } from 'redux'
import videoPopup from './videoPopup/reducer'

const rootReducer = combineReducers({
  videoPopup,
})

export default rootReducer
